export default __webpack_public_path__ + "static/media/mapMarker.0e8309f0.svg";